import {Injectable} from "@angular/core";
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from "@angular/common/http";
import {Observable} from "rxjs";
import {AuthService} from "./auth.service";
import {Router} from "@angular/router";
import {isValid} from "./auth.helpers";
import {LoadingService} from "@core/_services/loading.service";
import {finalize} from "rxjs/operators";
import { getParseToken } from "@core/_utils/tools.utils";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public auth: AuthService, private router: Router, private loadingService: LoadingService) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        try {
            // Ne pas changer l'ordre
            if (!request.url.includes("/token")) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${this.auth.getToken()}`
                    }
                });
            }            
            if (request.url.includes("/getbskcount")) {
                return next.handle(request);
            }
            if (request.url.includes("/getbatchlist")) {
                return next.handle(request);
            }           
            if (request.url.includes("/getnotiflist")) {
                return next.handle(request);
            }   
            if (request.url.includes("/addattachedfile")) {
                return next.handle(request);
            }   
            if (request.url.includes("/senddocument")) {
                return next.handle(request);
            }                          
            if (request.url.includes("/getpage")) {
                this.loadingService.loadOptions(request.body.Page, request.body.Page);
            } else {
                const urlSegments = request.url.split('/');
                const lastSegment = urlSegments[urlSegments.length - 1];
                const subSegment = urlSegments[urlSegments.length - 2];
                this.loadingService.loadOptions(lastSegment, subSegment);
            }

            this.loadingService.setCount();
            const token = getParseToken();
            if (token) {
                if (!isValid(token.token) && !request.url.includes("/token")) {
                    this.router.navigate(["expired"]);
                }
            } else {
                this.router.navigate(["login"]);
            }
        } catch(error) {            
            this.loadingService.loading = false;
        }
        return next.handle(request).pipe(
            finalize(() => {
                if (this.loadingService.loading) {
                    this.loadingService.count--;
                    this.loadingService.calculateProgress();
                }
                if (this.loadingService.count === 0) {
                    this.loadingService.loading = false;
                }
            })
        )
    }
}


